import { useState } from 'react';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';

interface PrefectureFlower {
  id: number;
  prefecture: string;
  flower: string;
  flowerEnglish: string;
  description: string;
  adoptedYear: string;
  reason: string;
  image: string;
  region: string;
  coordinates: {
    lat: number;
    lng: number;
  };
}

const prefectureFlowers: PrefectureFlower[] = [
  {
    id: 1,
    prefecture: '北海道',
    flower: 'ハマナス',
    flowerEnglish: 'Rosa rugosa',
    description: '北海道の海岸に自生する野生のバラ。濃いピンクの花と赤い実が美しく、厳しい寒さにも耐える強さを持っています。',
    adoptedYear: '1954年',
    reason: '北海道の自然環境に適応し、道民に親しまれている花として選定されました。',
    image: 'https://public.readdy.ai/ai/img_res/848dfe7f02ca1259ddd5d52253527f25.jpg',
    region: '北海道',
    coordinates: { lat: 43.2203, lng: 142.8635 }
  },
  {
    id: 2,
    prefecture: '青森県',
    flower: 'リンゴの花',
    flowerEnglish: 'Apple Blossom',
    description: '青森県の代表的な産業であるリンゴの白い花。春に咲く清楚で美しい花は、豊かな実りの象徴です。',
    adoptedYear: '1971年',
    reason: 'リンゴ生産量日本一の青森県を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20apple%20blossoms%20in%20full%20bloom%20in%20Aomori%20orchard%2C%20delicate%20white%20petals%20with%20pink%20edges%2C%20spring%20season%20atmosphere%2C%20detailed%20botanical%20photography%2C%20fruit%20tree%20flowers%20in%20Japanese%20countryside&width=400&height=300&seq=apple-blossom-1&orientation=landscape',
    region: '東北',
    coordinates: { lat: 40.8244, lng: 140.74 }
  },
  {
    id: 3,
    prefecture: '岩手県',
    flower: 'キリ',
    flowerEnglish: 'Paulownia',
    description: '薄紫色の美しい花を咲かせるキリの木。古くから高級木材として重宝され、岩手県の山々に自生しています。',
    adoptedYear: '1965年',
    reason: '県内に多く自生し、県民に親しまれている花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20purple%20paulownia%20flowers%20blooming%20on%20tall%20tree%2C%20elegant%20lavender%20colored%20blossoms%2C%20spring%20season%20in%20Iwate%20mountains%2C%20detailed%20botanical%20photography%2C%20traditional%20Japanese%20tree%20flowers&width=400&height=300&seq=paulownia-1&orientation=landscape',
    region: '東北',
    coordinates: { lat: 39.7036, lng: 141.1527 }
  },
  {
    id: 4,
    prefecture: '宮城県',
    flower: 'ミヤギノハギ',
    flowerEnglish: 'Miyagi Bush Clover',
    description: '宮城県の名前を冠した萩の花。秋に咲く小さな紫色の花が美しく、古くから和歌にも詠まれています。',
    adoptedYear: '1955年',
    reason: '県名にちなんだ花で、県民に愛され続けている花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20miyagi%20bush%20clover%20flowers%20in%20autumn%2C%20small%20purple%20blossoms%20on%20graceful%20branches%2C%20traditional%20Japanese%20garden%20setting%2C%20detailed%20botanical%20photography%2C%20elegant%20fall%20flowering%20plant&width=400&height=300&seq=miyagi-hagi-1&orientation=landscape',
    region: '東北',
    coordinates: { lat: 38.2682, lng: 140.8694 }
  },
  {
    id: 5,
    prefecture: '秋田県',
    flower: 'フキノトウ',
    flowerEnglish: 'Butterbur Sprout',
    description: '春の訪れを告げるフキノトウ。雪解けとともに顔を出す黄色い花は、秋田の厳しい冬を乗り越えた生命力の象徴です。',
    adoptedYear: '1965年',
    reason: '秋田の春を代表する山菜として県民に親しまれている花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20butterbur%20sprouts%20emerging%20from%20snow%20in%20early%20spring%20Akita%2C%20yellow%20flower%20buds%20breaking%20through%20ground%2C%20natural%20mountain%20setting%2C%20detailed%20botanical%20photography%2C%20Japanese%20spring%20wildflower&width=400&height=300&seq=fukinotou-1&orientation=landscape',
    region: '東北',
    coordinates: { lat: 39.7186, lng: 140.1024 }
  },
  {
    id: 6,
    prefecture: '山形県',
    flower: 'ベニバナ',
    flowerEnglish: 'Safflower',
    description: '山形県の特産品として有名なベニバナ。鮮やかな黄色から赤色に変化する花は、染料や化粧品の原料として古くから利用されています。',
    adoptedYear: '1982年',
    reason: '山形県の代表的な特産品で、県の歴史と文化を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20safflower%20field%20in%20Yamagata%20prefecture%2C%20bright%20yellow%20and%20red%20thistle-like%20flowers%2C%20traditional%20Japanese%20cultivation%2C%20detailed%20botanical%20photography%2C%20summer%20blooming%20crop%20flowers&width=400&height=300&seq=safflower-1&orientation=landscape',
    region: '東北',
    coordinates: { lat: 38.2404, lng: 140.3633 }
  },
  {
    id: 7,
    prefecture: '福島県',
    flower: 'ネモトシャクナゲ',
    flowerEnglish: 'Rhododendron',
    description: '福島県の山々に自生するシャクナゲ。ピンクや白の美しい花を咲かせ、高山植物の女王とも呼ばれています。',
    adoptedYear: '1954年',
    reason: '県内の山地に広く分布し、美しい花で県民に愛されている花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20rhododendron%20flowers%20blooming%20in%20Fukushima%20mountains%2C%20pink%20and%20white%20clustered%20blossoms%2C%20alpine%20setting%20with%20green%20foliage%2C%20detailed%20botanical%20photography%2C%20Japanese%20mountain%20wildflower&width=400&height=300&seq=rhododendron-1&orientation=landscape',
    region: '東北',
    coordinates: { lat: 37.7503, lng: 140.4676 }
  },
  {
    id: 8,
    prefecture: '茨城県',
    flower: 'バラ',
    flowerEnglish: 'Rose',
    description: '花の女王と呼ばれるバラ。茨城県では多くの品種が栽培され、美しい花と香りで人々を魅了しています。',
    adoptedYear: '1966年',
    reason: '美しさと気品を兼ね備えた花として、県民に愛されている花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20roses%20in%20full%20bloom%20in%20Ibaraki%20garden%2C%20elegant%20velvety%20petals%20with%20morning%20dew%2C%20romantic%20garden%20setting%2C%20detailed%20botanical%20photography%2C%20classic%20flower%20arrangement%20style&width=400&height=300&seq=rose-ibaraki-1&orientation=landscape',
    region: '関東',
    coordinates: { lat: 36.3418, lng: 140.4468 }
  },
  {
    id: 9,
    prefecture: '栃木県',
    flower: 'ヤシオツツジ',
    flowerEnglish: 'Yashio Azalea',
    description: '栃木県の山々に自生するツツジの一種。薄紫色の美しい花を咲かせ、春の山を彩ります。',
    adoptedYear: '1961年',
    reason: '県内の山地に広く分布し、県民に親しまれている花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20yashio%20azalea%20flowers%20blooming%20in%20Tochigi%20mountains%2C%20light%20purple%20delicate%20blossoms%2C%20spring%20mountain%20setting%2C%20detailed%20botanical%20photography%2C%20Japanese%20alpine%20flowering%20shrub&width=400&height=300&seq=yashio-azalea-1&orientation=landscape',
    region: '関東',
    coordinates: { lat: 36.5658, lng: 139.8836 }
  },
  {
    id: 10,
    prefecture: '群馬県',
    flower: 'レンゲツツジ',
    flowerEnglish: 'Japanese Azalea',
    description: '群馬県の高原に咲くオレンジ色のツツジ。尾瀬や赤城山などで美しい群生を見ることができます。',
    adoptedYear: '1961年',
    reason: '県内の高原地帯に広く分布し、観光資源としても重要な花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20orange%20japanese%20azalea%20flowers%20blooming%20in%20Gunma%20highlands%2C%20vibrant%20orange-red%20blossoms%20in%20mountain%20meadow%2C%20spring%20season%20atmosphere%2C%20detailed%20botanical%20photography%2C%20alpine%20flowering%20landscape&width=400&height=300&seq=renge-azalea-1&orientation=landscape',
    region: '関東',
    coordinates: { lat: 36.3914, lng: 139.0608 }
  },
  {
    id: 11,
    prefecture: '埼玉県',
    flower: 'サクラソウ',
    flowerEnglish: 'Japanese Primrose',
    description: '埼玉県の荒川流域に自生する可憐な花。ピンクの小さな花が群生して咲く姿は春の風物詩です。',
    adoptedYear: '1971年',
    reason: '県内の自然環境を代表する花で、保護活動も行われている貴重な花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20primrose%20flowers%20blooming%20along%20Arakawa%20river%20in%20Saitama%2C%20delicate%20pink%20blossoms%20in%20natural%20wetland%2C%20spring%20wildflower%20meadow%2C%20detailed%20botanical%20photography%2C%20native%20Japanese%20flora&width=400&height=300&seq=sakurasou-1&orientation=landscape',
    region: '関東',
    coordinates: { lat: 35.8617, lng: 139.6455 }
  },
  {
    id: 12,
    prefecture: '千葉県',
    flower: 'ナノハナ',
    flowerEnglish: 'Rapeseed Flower',
    description: '千葉県の春を代表する黄色い菜の花。房総半島の丘陵地帯に広がる菜の花畑は観光名所としても人気です。',
    adoptedYear: '1954年',
    reason: '県内各地で栽培され、春の風景を彩る代表的な花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20yellow%20rapeseed%20flower%20field%20in%20Chiba%20Boso%20peninsula%2C%20bright%20golden%20blossoms%20covering%20rolling%20hills%2C%20spring%20season%20landscape%2C%20detailed%20botanical%20photography%2C%20Japanese%20countryside%20scenery&width=400&height=300&seq=nanohana-1&orientation=landscape',
    region: '関東',
    coordinates: { lat: 35.6047, lng: 140.1233 }
  },
  {
    id: 13,
    prefecture: '東京都',
    flower: 'ソメイヨシノ',
    flowerEnglish: 'Yoshino Cherry',
    description: '日本を代表する桜の品種。東京の春を彩る美しい淡いピンクの花は、多くの人々に愛され続けています。',
    adoptedYear: '1964年',
    reason: '都民に最も親しまれている花で、東京の春の象徴として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20yoshino%20cherry%20blossoms%20in%20full%20bloom%20in%20Tokyo%2C%20delicate%20pale%20pink%20petals%20against%20blue%20sky%2C%20urban%20park%20setting%20with%20traditional%20Japanese%20atmosphere%2C%20detailed%20botanical%20photography%2C%20spring%20sakura%20season&width=400&height=300&seq=yoshino-cherry-1&orientation=landscape',
    region: '関東',
    coordinates: { lat: 35.6762, lng: 139.6503 }
  },
  {
    id: 14,
    prefecture: '神奈川県',
    flower: 'ヤマユリ',
    flowerEnglish: 'Golden-rayed Lily',
    description: '神奈川県の山地に自生する大型のユリ。白い花弁に黄色い筋と赤い斑点が美しく、芳香も楽しめます。',
    adoptedYear: '1951年',
    reason: '県内の山地に広く自生し、県民に親しまれている美しい花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20golden-rayed%20lily%20flowers%20blooming%20in%20Kanagawa%20mountains%2C%20large%20white%20petals%20with%20yellow%20stripes%20and%20red%20spots%2C%20natural%20forest%20setting%2C%20detailed%20botanical%20photography%2C%20Japanese%20native%20lily%20species&width=400&height=300&seq=yamayuri-1&orientation=landscape',
    region: '関東',
    coordinates: { lat: 35.4478, lng: 139.6425 }
  },
  {
    id: 15,
    prefecture: '新潟県',
    flower: 'チューリップ',
    flowerEnglish: 'Tulip',
    description: '新潟県の代表的な花卉産業であるチューリップ。色とりどりの美しい花は春の訪れを告げる象徴です。',
    adoptedYear: '1963年',
    reason: 'チューリップの球根生産量日本一の新潟県を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20colorful%20tulip%20field%20in%20Niigata%20prefecture%2C%20vibrant%20red%20yellow%20pink%20tulips%20in%20rows%2C%20spring%20season%20atmosphere%2C%20detailed%20botanical%20photography%2C%20Japanese%20tulip%20cultivation%20landscape&width=400&height=300&seq=tulip-niigata-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 37.9026, lng: 139.0232 }
  },
  {
    id: 16,
    prefecture: '富山県',
    flower: 'チューリップ',
    flowerEnglish: 'Tulip',
    description: '富山県の代表的な花卉産業であるチューリップ。砺波平野の美しいチューリップ畑は全国的に有名です。',
    adoptedYear: '1954年',
    reason: 'チューリップの球根生産で有名な富山県を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tulip%20field%20in%20Toyama%20Tonami%20plain%2C%20colorful%20tulips%20with%20Tateyama%20mountains%20background%2C%20spring%20season%20landscape%2C%20detailed%20botanical%20photography%2C%20Japanese%20tulip%20festival%20scenery&width=400&height=300&seq=tulip-toyama-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 36.6953, lng: 137.2113 }
  },
  {
    id: 17,
    prefecture: '石川県',
    flower: 'クロユリ',
    flowerEnglish: 'Black Lily',
    description: '石川県の高山に自生する珍しい黒紫色のユリ。白山などの高山植物として貴重な存在です。',
    adoptedYear: '1954年',
    reason: '県内の高山地帯に自生する貴重な花で、石川県の自然を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20black%20lily%20flowers%20blooming%20in%20Ishikawa%20alpine%20region%2C%20dark%20purple-black%20petals%20in%20mountain%20setting%2C%20rare%20Japanese%20mountain%20wildflower%2C%20detailed%20botanical%20photography%2C%20high%20altitude%20flora&width=400&height=300&seq=black-lily-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 36.5944, lng: 136.6256 }
  },
  {
    id: 18,
    prefecture: '福井県',
    flower: 'スイセン',
    flowerEnglish: 'Narcissus',
    description: '福井県の越前海岸に群生するスイセン。冬から春にかけて咲く白い花は、厳しい日本海の風雪に耐える強さを持っています。',
    adoptedYear: '1954年',
    reason: '越前海岸の群生地で有名で、県民に親しまれている花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20narcissus%20flowers%20blooming%20on%20Echizen%20coast%20in%20Fukui%2C%20white%20flowers%20with%20yellow%20centers%20along%20seaside%20cliffs%2C%20winter%20to%20spring%20season%2C%20detailed%20botanical%20photography%2C%20Japanese%20coastal%20wildflower&width=400&height=300&seq=narcissus-fukui-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 36.0652, lng: 136.2217 }
  },
  {
    id: 19,
    prefecture: '山梨県',
    flower: 'フジザクラ',
    flowerEnglish: 'Fuji Cherry',
    description: '富士山周辺に自生する桜の一種。小さな白い花を咲かせ、富士山の美しい景観と調和しています。',
    adoptedYear: '1954年',
    reason: '富士山周辺に自生し、山梨県の象徴である富士山と深く関わりのある花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20fuji%20cherry%20blossoms%20blooming%20around%20Mount%20Fuji%20in%20Yamanashi%2C%20small%20white%20flowers%20with%20mountain%20background%2C%20spring%20season%20atmosphere%2C%20detailed%20botanical%20photography%2C%20Japanese%20mountain%20cherry%20species&width=400&height=300&seq=fuji-cherry-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 35.6638, lng: 138.5681 }
  },
  {
    id: 20,
    prefecture: '長野県',
    flower: 'リンドウ',
    flowerEnglish: 'Gentian',
    description: '長野県の高原に咲く美しい青紫色の花。秋の高原を彩る代表的な花で、清楚で上品な美しさを持っています。',
    adoptedYear: '1966年',
    reason: '県内の高原地帯に広く分布し、長野県の自然を代表する美しい花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20gentian%20flowers%20blooming%20in%20Nagano%20highlands%2C%20deep%20blue-purple%20bell-shaped%20blossoms%2C%20autumn%20mountain%20meadow%20setting%2C%20detailed%20botanical%20photography%2C%20Japanese%20alpine%20wildflower&width=400&height=300&seq=gentian-nagano-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 36.6513, lng: 138.1811 }
  },
  {
    id: 21,
    prefecture: '岐阜県',
    flower: 'レンゲソウ',
    flowerEnglish: 'Chinese Milk Vetch',
    description: '岐阜県の田園地帯に咲く紫色の小さな花。春の田んぼを美しく彩り、農業と深く関わりのある花です。',
    adoptedYear: '1954年',
    reason: '県内の農村地帯に広く分布し、岐阜県の農業文化を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20chinese%20milk%20vetch%20flowers%20blooming%20in%20Gifu%20rice%20fields%2C%20purple%20clover-like%20blossoms%20in%20rural%20setting%2C%20spring%20agricultural%20landscape%2C%20detailed%20botanical%20photography%2C%20Japanese%20countryside%20wildflower&width=400&height=300&seq=renge-gifu-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 35.3912, lng: 136.7223 }
  },
  {
    id: 22,
    prefecture: '静岡県',
    flower: 'ツツジ',
    flowerEnglish: 'Azalea',
    description: '静岡県の山々に咲く美しいツツジ。ピンクや白の花が春の山を彩り、多くの観光客を魅了しています。',
    adoptedYear: '1965年',
    reason: '県内の山地に広く分布し、静岡県の自然美を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20azalea%20flowers%20blooming%20in%20Shizuoka%20mountains%2C%20pink%20and%20white%20blossoms%20covering%20hillsides%2C%20spring%20season%20with%20Mount%20Fuji%20background%2C%20detailed%20botanical%20photography%2C%20Japanese%20mountain%20flowering%20shrub&width=400&height=300&seq=azalea-shizuoka-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 34.9769, lng: 138.3831 }
  },
  {
    id: 23,
    prefecture: '愛知県',
    flower: 'カキツバタ',
    flowerEnglish: 'Rabbitear Iris',
    description: '愛知県の湿地に咲く美しい紫色のアヤメ科の花。知立市の無量寿寺などで見ることができる古典的な花です。',
    adoptedYear: '1954年',
    reason: '古くから県内で親しまれ、文学作品にも登場する歴史ある花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20rabbitear%20iris%20flowers%20blooming%20in%20Aichi%20wetland%2C%20elegant%20purple%20petals%20in%20pond%20setting%2C%20traditional%20Japanese%20garden%20atmosphere%2C%20detailed%20botanical%20photography%2C%20classic%20Japanese%20water%20iris&width=400&height=300&seq=kakitsubata-1&orientation=landscape',
    region: '中部',
    coordinates: { lat: 35.1802, lng: 136.9066 }
  },
  {
    id: 24,
    prefecture: '三重県',
    flower: 'ハナショウブ',
    flowerEnglish: 'Japanese Iris',
    description: '三重県の水辺に咲く美しい花菖蒲。紫や白の大きな花が初夏の水辺を彩ります。',
    adoptedYear: '1969年',
    reason: '県内の水辺環境を代表する美しい花として、県民に愛されている花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20iris%20flowers%20blooming%20in%20Mie%20prefecture%20waterside%2C%20large%20purple%20and%20white%20petals%20near%20pond%2C%20early%20summer%20season%20atmosphere%2C%20detailed%20botanical%20photography%2C%20traditional%20Japanese%20water%20garden%20flower&width=400&height=300&seq=hanashobu-mie-1&orientation=landscape',
    region: '関西',
    coordinates: { lat: 34.7303, lng: 136.5086 }
  },
  {
    id: 25,
    prefecture: '滋賀県',
    flower: 'シャクナゲ',
    flowerEnglish: 'Rhododendron',
    description: '滋賀県の山々に咲く美しいシャクナゲ。ピンクや白の大きな花房が春の山を華やかに彩ります。',
    adoptedYear: '1971年',
    reason: '県内の山地に広く分布し、滋賀県の自然を代表する美しい花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20rhododendron%20flowers%20blooming%20in%20Shiga%20mountains%2C%20large%20pink%20and%20white%20flower%20clusters%2C%20spring%20mountain%20setting%20near%20Lake%20Biwa%2C%20detailed%20botanical%20photography%2C%20Japanese%20mountain%20flowering%20shrub&width=400&height=300&seq=rhododendron-shiga-1&orientation=landscape',
    region: '関西',
    coordinates: { lat: 35.0045, lng: 135.8686 }
  },
  {
    id: 26,
    prefecture: '京都府',
    flower: 'しだれ桜',
    flowerEnglish: 'Weeping Cherry',
    description: '京都府を代表する優雅な桜。枝垂れる枝に咲く淡いピンクの花は、古都京都の風情を演出します。',
    adoptedYear: '1954年',
    reason: '古都京都の歴史と文化を象徴する美しい花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20weeping%20cherry%20blossoms%20in%20Kyoto%20temple%20garden%2C%20graceful%20drooping%20branches%20with%20pale%20pink%20flowers%2C%20traditional%20Japanese%20architecture%20background%2C%20detailed%20botanical%20photography%2C%20classic%20Kyoto%20spring%20scenery&width=400&height=300&seq=weeping-cherry-kyoto-1&orientation=landscape',
    region: '関西',
    coordinates: { lat: 35.0116, lng: 135.7681 }
  },
  {
    id: 27,
    prefecture: '大阪府',
    flower: 'ウメ',
    flowerEnglish: 'Japanese Plum',
    description: '大阪府を代表する梅の花。早春に咲く白やピンクの花は、春の訪れを告げる美しい花です。',
    adoptedYear: '1966年',
    reason: '古くから府民に親しまれ、大阪の春を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20plum%20blossoms%20in%20Osaka%20park%2C%20white%20and%20pink%20flowers%20on%20bare%20branches%2C%20early%20spring%20atmosphere%2C%20detailed%20botanical%20photography%2C%20traditional%20Japanese%20plum%20garden%20setting&width=400&height=300&seq=plum-osaka-1&orientation=landscape',
    region: '関西',
    coordinates: { lat: 34.6937, lng: 135.5023 }
  },
  {
    id: 28,
    prefecture: '兵庫県',
    flower: 'ノジギク',
    flowerEnglish: 'Wild Chrysanthemum',
    description: '兵庫県の海岸や山地に自生する野菊。白い小さな花が秋の野山を美しく彩ります。',
    adoptedYear: '1954年',
    reason: '県内に広く自生し、兵庫県の自然を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20wild%20chrysanthemum%20flowers%20blooming%20in%20Hyogo%20countryside%2C%20small%20white%20daisy-like%20blossoms%20in%20autumn%20field%2C%20natural%20grassland%20setting%2C%20detailed%20botanical%20photography%2C%20Japanese%20native%20wildflower&width=400&height=300&seq=nojigiku-1&orientation=landscape',
    region: '関西',
    coordinates: { lat: 34.6913, lng: 135.1830 }
  },
  {
    id: 29,
    prefecture: '奈良県',
    flower: 'ナラノヤエザクラ',
    flowerEnglish: 'Nara Double Cherry',
    description: '奈良県原産の八重桜。淡いピンクの八重の花が美しく、奈良公園などで見ることができます。',
    adoptedYear: '1968年',
    reason: '奈良県原産の桜で、古都奈良の歴史と文化を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Nara%20double%20cherry%20blossoms%20in%20historic%20park%2C%20pale%20pink%20double-petaled%20flowers%20with%20deer%20in%20background%2C%20spring%20season%20in%20ancient%20capital%2C%20detailed%20botanical%20photography%2C%20traditional%20Japanese%20cherry%20variety&width=400&height=300&seq=nara-yaezakura-1&orientation=landscape',
    region: '関西',
    coordinates: { lat: 34.6851, lng: 135.8048 }
  },
  {
    id: 30,
    prefecture: '和歌山県',
    flower: 'ウメ',
    flowerEnglish: 'Japanese Plum',
    description: '和歌山県の代表的な特産品である梅の花。南高梅で有名な和歌山県を象徴する美しい花です。',
    adoptedYear: '1965年',
    reason: '梅の生産量日本一の和歌山県を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20plum%20blossoms%20in%20Wakayama%20orchard%2C%20white%20flowers%20on%20plum%20trees%20in%20mountainous%20region%2C%20early%20spring%20agricultural%20landscape%2C%20detailed%20botanical%20photography%2C%20famous%20Nanko%20plum%20cultivation%20area&width=400&height=300&seq=plum-wakayama-1&orientation=landscape',
    region: '関西',
    coordinates: { lat: 34.2261, lng: 135.1675 }
  },
  {
    id: 31,
    prefecture: '鳥取県',
    flower: '二十世紀梨の花',
    flowerEnglish: 'Nijisseiki Pear Blossom',
    description: '鳥取県の特産品である二十世紀梨の白い花。春に咲く清楚な花は、豊かな実りの象徴です。',
    adoptedYear: '1954年',
    reason: '二十世紀梨の産地として有名な鳥取県を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20nijisseiki%20pear%20blossoms%20in%20Tottori%20orchard%2C%20white%20flowers%20on%20pear%20trees%2C%20spring%20season%20agricultural%20landscape%2C%20detailed%20botanical%20photography%2C%20famous%20Japanese%20pear%20cultivation%20region&width=400&height=300&seq=pear-blossom-tottori-1&orientation=landscape',
    region: '中国',
    coordinates: { lat: 35.5038, lng: 134.2384 }
  },
  {
    id: 32,
    prefecture: '島根県',
    flower: 'ボタン',
    flowerEnglish: 'Tree Peony',
    description: '島根県大根島で栽培される美しい牡丹。大きく華やかな花は「花の王様」と呼ばれています。',
    adoptedYear: '1954年',
    reason: '大根島の牡丹栽培で有名な島根県を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tree%20peony%20flowers%20blooming%20in%20Shimane%20Daikonshima%20island%2C%20large%20pink%20and%20white%20ruffled%20petals%2C%20traditional%20Japanese%20peony%20garden%2C%20detailed%20botanical%20photography%2C%20luxury%20flowering%20shrub&width=400&height=300&seq=peony-shimane-1&orientation=landscape',
    region: '中国',
    coordinates: { lat: 35.4723, lng: 133.0505 }
  },
  {
    id: 33,
    prefecture: '岡山県',
    flower: 'モモ',
    flowerEnglish: 'Peach Blossom',
    description: '岡山県の代表的な果物である桃の花。春に咲くピンクの美しい花は、桃太郎の里にふさわしい花です。',
    adoptedYear: '1951年',
    reason: '桃の産地として有名で、桃太郎伝説の地である岡山県を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20peach%20blossoms%20in%20Okayama%20orchard%2C%20pink%20flowers%20on%20peach%20trees%2C%20spring%20season%20fruit%20cultivation%20landscape%2C%20detailed%20botanical%20photography%2C%20famous%20Japanese%20peach%20growing%20region&width=400&height=300&seq=peach-blastoma-1&orientation=landscape',
    region: '中国',
    coordinates: { lat: 34.6617, lng: 133.9341 }
  },
  {
    id: 34,
    prefecture: '広島県',
    flower: 'モミジ',
    flowerEnglish: 'Japanese Maple',
    description: '広島県の宮島などで有名な紅葉の美しいモミジ。春の新緑から秋の紅葉まで四季を通じて美しい葉を楽しめます。',
    adoptedYear: '1966年',
    reason: '宮島の紅葉で有名で、広島県の自然美を代表する植物として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20maple%20leaves%20in%20Hiroshima%20Miyajima%2C%20vibrant%20red%20autumn%20foliage%20with%20traditional%20torii%20gate%20background%2C%20seasonal%20color%20change%2C%20detailed%20botanical%20photography%2C%20famous%20Japanese%20maple%20scenery&width=400&height=300&seq=maple-hiroshima-1&orientation=landscape',
    region: '中国',
    coordinates: { lat: 34.3853, lng: 132.4553 }
  },
  {
    id: 35,
    prefecture: '山口県',
    flower: 'ナツミカンの花',
    flowerEnglish: 'Summer Orange Blossom',
    description: '山口県萩市の特産品である夏みかんの白い花。芳香があり、初夏の萩の町を美しく彩ります。',
    adoptedYear: '1954年',
    reason: '萩市の夏みかん栽培で有名で、山口県の歴史と文化を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20summer%20orange%20blossoms%20in%20Yamaguchi%20Hagi%20city%2C%20white%20fragrant%20flowers%20on%20citrus%20trees%2C%20traditional%20Japanese%20town%20setting%2C%20detailed%20botanical%20photography%2C%20historic%20citrus%20cultivation%20area&width=400&height=300&seq=summer-orange-yamaguchi-1&orientation=landscape',
    region: '中国',
    coordinates: { lat: 34.1859, lng: 131.4706 }
  },
  {
    id: 36,
    prefecture: '徳島県',
    flower: 'スダチの花',
    flowerEnglish: 'Sudachi Citrus Blossom',
    description: '徳島県の特産品であるスダチの白い小さな花。芳香があり、徳島県の農業を象徴する花です。',
    adoptedYear: '1954年',
    reason: 'スダチの生産量日本一の徳島県を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20sudachi%20citrus%20blossoms%20in%20Tokushima%20orchard%2C%20small%20white%20fragrant%20flowers%20on%20citrus%20trees%2C%20spring%20agricultural%20landscape%2C%20detailed%20botanical%20photography%2C%20famous%20Japanese%20citrus%20cultivation&width=400&height=300&seq=sudachi-blossom-1&orientation=landscape',
    region: '四国',
    coordinates: { lat: 34.0658, lng: 134.5594 }
  },
  {
    id: 37,
    prefecture: '香川県',
    flower: 'オリーブ',
    flowerEnglish: 'Olive Blossom',
    description: '香川県小豆島の特産品であるオリーブの小さな白い花。地中海の雰囲気を醸し出す美しい花です。',
    adoptedYear: '1966年',
    reason: '小豆島のオリーブ栽培で有名で、香川県の特色ある農業を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20olive%20blossoms%20in%20Kagawa%20Shodoshima%20island%2C%20small%20white%20flowers%20on%20olive%20trees%2C%20Mediterranean%20atmosphere%20in%20Japanese%20setting%2C%20detailed%20botanical%20photography%2C%20unique%20Japanese%20olive%20cultivation&width=400&height=300&seq=olive-blossom-1&orientation=landscape',
    region: '四国',
    coordinates: { lat: 34.3401, lng: 134.0434 }
  },
  {
    id: 38,
    prefecture: '愛媛県',
    flower: 'ミカンの花',
    flowerEnglish: 'Mandarin Orange Blossom',
    description: '愛媛県の代表的な特産品であるみかんの白い花。芳香があり、愛媛県の温暖な気候を象徴する花です。',
    adoptedYear: '1951年',
    reason: 'みかんの生産量日本一の愛媛県を代表する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20mandarin%20orange%20blossoms%20in%20Ehime%20orchard%2C%20white%20fragrant%20flowers%20on%20citrus%20trees%2C%20terraced%20hillside%20cultivation%2C%20detailed%20botanical%20photography%2C%20famous%20Japanese%20citrus%20growing%20region&width=400&height=300&seq=mandarin-blossom-1&orientation=landscape',
    region: '四国',
    coordinates: { lat: 33.8416, lng: 132.7658 }
  },
  {
    id: 39,
    prefecture: '高知県',
    flower: 'ヤマモモ',
    flowerEnglish: 'Japanese Bayberry',
    description: '高知県の山地に自生するヤマモモ。赤い実で知られていますが、春に咲く小さな花も美しく、県の自然を象徴しています。',
    adoptedYear: '1954年',
    reason: '県内に広く自生し、高知県の豊かな自然を代表する植物として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20bayberry%20flowers%20and%20fruits%20in%20Kochi%20mountains%2C%20small%20flowers%20and%20red%20berries%20on%20tree%2C%20natural%20forest%20setting%2C%20detailed%20botanical%20photography%2C%20native%20Japanese%20mountain%20tree&width=400&height=300&seq=yamamoto-kochi-1&orientation=landscape',
    region: '四国',
    coordinates: { lat: 33.5597, lng: 133.5311 }
  },
  {
    id: 40,
    prefecture: '福岡県',
    flower: 'ウメ',
    flowerEnglish: 'Japanese Plum',
    description: '福岡県太宰府天満宮で有名な梅の花。学問の神様である菅原道真公ゆかりの美しい花です。',
    adoptedYear: '1954年',
    reason: '太宰府天満宮の梅で有名で、福岡県の歴史と文化を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20plum%20blossoms%20at%20Fukuoka%20Dazaifu%20Tenmangu%20shrine%2C%20white%20and%20pink%20flowers%20with%20traditional%20architecture%20background%2C%20early%20spring%20religious%20setting%2C%20detailed%20botanical%20photography%2C%20historic%20Japanese%20plum%20garden&width=400&height=300&seq=plum-fukuoka-1&orientation=landscape',
    region: '九州',
    coordinates: { lat: 33.6064, lng: 130.4181 }
  },
  {
    id: 41,
    prefecture: '佐賀県',
    flower: 'クスノキ',
    flowerEnglish: 'Camphor Tree',
    description: '佐賀県の各地に見られる大きなクスノキ。初夏に咲く小さな黄緑色の花は控えめながら美しく、長寿の象徴でもあります。',
    adoptedYear: '1954年',
    reason: '県内各地に巨木があり、佐賀県の自然と歴史を象徴する木として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20camphor%20tree%20flowers%20in%20Saga%20prefecture%2C%20small%20yellowish-green%20blossoms%20on%20large%20ancient%20tree%2C%20traditional%20Japanese%20village%20setting%2C%20detailed%20botanical%20photography%2C%20majestic%20old%20growth%20tree&width=400&height=300&seq=camphor-saga-1&orientation=landscape',
    region: '九州',
    coordinates: { lat: 33.2494, lng: 130.2989 }
  },
  {
    id: 42,
    prefecture: '長崎県',
    flower: 'ウンゼンツツジ',
    flowerEnglish: 'Unzen Azalea',
    description: '長崎県雲仙地域に自生するツツジ。鮮やかなピンクの花が雲仙の山々を美しく彩ります。',
    adoptedYear: '1954年',
    reason: '雲仙地域の代表的な花で、長崎県の自然美を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Unzen%20azalea%20flowers%20blooming%20in%20Nagasaki%20mountains%2C%20vibrant%20pink%20blossoms%20covering%20volcanic%20slopes%2C%20spring%20season%20mountain%20landscape%2C%20detailed%20botanical%20photography%2C%20unique%20Japanese%20mountain%20azalea&width=400&height=300&seq=unzen-azalea-1&orientation=landscape',
    region: '九州',
    coordinates: { lat: 32.7503, lng: 129.8737 }
  },
  {
    id: 43,
    prefecture: '熊本県',
    flower: 'リンドウ',
    flowerEnglish: 'Gentian',
    description: '熊本県の阿蘇高原に咲く美しい青紫色のリンドウ。秋の草原を彩る代表的な花です。',
    adoptedYear: '1954年',
    reason: '阿蘇高原の代表的な花で、熊本県の雄大な自然を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20gentian%20flowers%20blooming%20in%20Kumamoto%20Aso%20highlands%2C%20deep%20blue-purple%20bell-shaped%20blossoms%20in%20grassland%2C%20autumn%20mountain%20meadow%20with%20volcanic%20landscape%2C%20detailed%20botanical%20photography%2C%20Japanese%20alpine%20wildflower&width=400&height=300&seq=gentian-kumamoto-1&orientation=landscape',
    region: '九州',
    coordinates: { lat: 32.7898, lng: 130.7417 }
  },
  {
    id: 44,
    prefecture: '大分県',
    flower: 'ブンゴウメ',
    flowerEnglish: 'Bungo Plum',
    description: '大分県原産の梅の品種。大きな白い花を咲かせ、豊後の名前を冠した美しい梅です。',
    adoptedYear: '1954年',
    reason: '大分県（旧豊後国）原産の梅で、県の歴史と文化を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Bungo%20plum%20blossoms%20in%20Oita%20prefecture%2C%20large%20white%20flowers%20on%20plum%20trees%2C%20traditional%20Japanese%20plum%20variety%2C%20detailed%20botanical%20photography%2C%20historic%20Japanese%20plum%20cultivation&width=400&height=300&seq=bungo-plum-1&orientation=landscape',
    region: '九州',
    coordinates: { lat: 33.2382, lng: 131.6126 }
  },
  {
    id: 45,
    prefecture: '宮崎県',
    flower: 'ハマユウ',
    flowerEnglish: 'Spider Lily',
    description: '宮崎県の海岸に自生する白い大きな花。南国の雰囲気を醸し出す美しい花で、宮崎の温暖な気候を象徴しています。',
    adoptedYear: '1964年',
    reason: '県内の海岸地域に自生し、宮崎県の温暖な気候と自然を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20spider%20lily%20flowers%20blooming%20on%20Miyazaki%20coastline%2C%20large%20white%20fragrant%20blossoms%20near%20ocean%2C%20tropical%20atmosphere%20in%20Japanese%20setting%2C%20detailed%20botanical%20photography%2C%20coastal%20wildflower&width=400&height=300&seq=spider-lily-miyazaki-1&orientation=landscape',
    region: '九州',
    coordinates: { lat: 31.9077, lng: 131.4202 }
  },
  {
    id: 46,
    prefecture: '鹿児島県',
    flower: 'ミヤマキリシマ',
    flowerEnglish: 'Miyama Kirishima Azalea',
    description: '鹿児島県霧島山系に自生する小さなツツジ。ピンクの小さな花が山肌を美しく染める霧島の代表的な花です。',
    adoptedYear: '1954年',
    reason: '霧島山系の代表的な花で、鹿児島県の雄大な自然を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Miyama%20Kirishima%20azalea%20flowers%20blooming%20on%20Kagoshima%20volcanic%20mountains%2C%20small%20pink%20blossoms%20covering%20mountain%20slopes%2C%20spring%20season%20volcanic%20landscape%2C%20detailed%20botanical%20photography%2C%20unique%20Japanese%20mountain%20azalea&width=400&height=300&seq=miyama-kirishima-1&orientation=landscape',
    region: '九州',
    coordinates: { lat: 31.5604, lng: 130.5581 }
  },
  {
    id: 47,
    prefecture: '沖縄県',
    flower: 'デイゴ',
    flowerEnglish: 'Indian Coral Tree',
    description: '沖縄県の県花である真っ赤な花を咲かせるデイゴ。南国沖縄の象徴的な花で、鮮やかな赤色が印象的です。',
    adoptedYear: '1967年',
    reason: '沖縄の代表的な花で、南国の美しさと沖縄県の文化を象徴する花として選定されました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Indian%20coral%20tree%20flowers%20blooming%20in%20Okinawa%2C%20vibrant%20red%20blossoms%20on%20tropical%20tree%2C%20blue%20sky%20and%20ocean%20background%2C%20detailed%20botanical%20photography%2C%20iconic%20Okinawan%20flower&width=400&height=300&seq=deigo-okinawa-1&orientation=landscape',
    region: '九州',
    coordinates: { lat: 26.2124, lng: 127.6792 }
  }
];

// ... existing code ...

const regions = [
  { id: 'all', name: 'すべて', icon: 'ri-map-line' },
  { id: '北海道', name: '北海道', icon: 'ri-snowflake-line' },
  { id: '東北', name: '東北', icon: 'ri-mountain-line' },
  { id: '関東', name: '関東', icon: 'ri-building-line' },
  { id: '中部', name: '中部', icon: 'ri-landscape-line' },
  { id: '関西', name: '関西', icon: 'ri-ancient-gate-line' },
  { id: '中国', name: '中国', icon: 'ri-ship-line' },
  { id: '四国', name: '四国', icon: 'ri-leaf-line' },
  { id: '九州', name: '九州', icon: 'ri-fire-line' }
];

export default function PrefectureFlowers() {
  const [selectedRegion, setSelectedRegion] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFlower, setSelectedFlower] = useState<PrefectureFlower | null>(null);
  const [showMap, setShowMap] = useState(false);
  const [mapLocation, setMapLocation] = useState<{prefecture: string, coordinates: {lat: number, lng: number}} | null>(null);

  const filteredFlowers = prefectureFlowers.filter(flower => {
    const matchesRegion = selectedRegion === 'all' || flower.region === selectedRegion;
    const matchesSearch = flower.prefecture.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         flower.flower.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         flower.flowerEnglish.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesRegion && matchesSearch;
  });

  const handleLocationClick = (prefecture: string, coordinates: {lat: number, lng: number}) => {
    setMapLocation({ prefecture, coordinates });
    setShowMap(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20prefecture%20flowers%20map%20illustration%20with%20cherry%20blossoms%2C%20regional%20flowers%20across%20Japan%20landscape%2C%20traditional%20Japanese%20art%20style%2C%20colorful%20floral%20arrangement%20representing%20different%20regions%2C%20cultural%20heritage%20design&width=1920&height=600&seq=prefecture-flowers-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            都道府県の花
          </h1>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            日本全国47都道府県それぞれが定めた県花を紹介します。
            <br />
            各地域の自然と文化を象徴する美しい花々をご覧ください。
          </p>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 bg-gradient-to-br from-blue-50 to-green-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Search Bar */}
            <div className="mb-8">
              <div className="relative max-w-md mx-auto">
                <input
                  type="text"
                  placeholder="都道府県名や花の名前で検索..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-3 pl-12 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                />
                <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
              </div>
            </div>

            {/* Region Filter */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">地域</h3>
              <div className="flex flex-wrap justify-center gap-2">
                {regions.map((region) => (
                  <button
                    key={region.id}
                    onClick={() => setSelectedRegion(region.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedRegion === region.id
                        ? 'bg-blue-500 text-white'
                        : 'bg-white text-gray-700 hover:bg-blue-100'
                    }`}
                  >
                    <i className={`${region.icon} mr-2`}></i>
                    {region.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Prefecture Flowers Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              {filteredFlowers.length}都道府県の花
            </h2>
            <p className="text-gray-600">各地域の美しい県花をご覧ください</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredFlowers.map((flower) => (
              <div
                key={flower.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all group"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={flower.image}
                    alt={`${flower.prefecture}の花 ${flower.flower}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-medium text-gray-700">
                    {flower.region}
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-xl font-bold text-gray-800">{flower.prefecture}</h3>
                    <button
                      onClick={() => handleLocationClick(flower.prefecture, flower.coordinates)}
                      className="text-blue-500 hover:text-blue-600 transition-colors cursor-pointer"
                      title="地図で位置を確認"
                    >
                      <i className="ri-map-pin-line text-lg"></i>
                    </button>
                  </div>
                  <div className="mb-3">
                    <h4 className="text-lg font-semibold text-green-700 mb-1">{flower.flower}</h4>
                    <p className="text-sm text-gray-500 italic">{flower.flowerEnglish}</p>
                  </div>
                  <div className="mb-4">
                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                      制定年: {flower.adoptedYear}
                    </span>
                  </div>
                  <p className="text-gray-600 text-sm line-clamp-3 mb-4">{flower.description}</p>
                  <button
                    onClick={() => setSelectedFlower(flower)}
                    className="w-full bg-gradient-to-r from-blue-500 to-green-500 text-white py-2 rounded-lg font-medium hover:from-blue-600 hover:to-green-600 transition-all cursor-pointer whitespace-nowrap"
                  >
                    詳細を見る
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredFlowers.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">該当する都道府県が見つかりません</h3>
              <p className="text-gray-500">検索条件を変更してお試しください</p>
            </div>
          )}
        </div>
      </section>

      {/* Flower Detail Modal */}
      {selectedFlower && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <img
                src={selectedFlower.image}
                alt={`${selectedFlower.prefecture}の花 ${selectedFlower.flower}`}
                className="w-full h-64 object-cover object-top"
              />
              <button
                onClick={() => setSelectedFlower(null)}
                className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm w-10 h-10 rounded-full flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-8">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-800 mb-2">{selectedFlower.prefecture}</h2>
                  <h3 className="text-2xl font-semibold text-green-700 mb-1">{selectedFlower.flower}</h3>
                  <p className="text-gray-500 text-lg italic">{selectedFlower.flowerEnglish}</p>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-500 mb-1">制定年</div>
                  <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                    {selectedFlower.adoptedYear}
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="text-xl font-semibold text-gray-800 mb-3">花の説明</h4>
                <p className="text-gray-600 leading-relaxed">{selectedFlower.description}</p>
              </div>

              <div className="mb-6">
                <h4 className="text-xl font-semibold text-gray-800 mb-3">選定理由</h4>
                <p className="text-gray-600 leading-relaxed">{selectedFlower.reason}</p>
              </div>

              <div className="flex gap-4">
                <button
                  onClick={() => handleLocationClick(selectedFlower.prefecture, selectedFlower.coordinates)}
                  className="flex-1 bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-map-pin-line mr-2"></i>
                  地図で位置を確認
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Map Modal */}
      {showMap && mapLocation && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
            <div className="flex items-center justify-between p-6 border-b">
              <h3 className="text-2xl font-bold text-gray-800">{mapLocation.prefecture}の位置</h3>
              <button
                onClick={() => setShowMap(false)}
                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="h-96">
              <iframe
                src={`https://www.google.com/maps/embed/v1/view?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dO5A2vYoMsVAOM&center=${mapLocation.coordinates.lat},${mapLocation.coordinates.lng}&zoom=8`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`${mapLocation.prefecture}の地図`}
              ></iframe>
            </div>
            <div className="p-6 bg-gray-50">
              <p className="text-gray-600 text-center">
                <i className="ri-information-line mr-2"></i>
                {mapLocation.prefecture}の大まかな位置を表示しています
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Statistics Section */}
      <section className="py-16 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">県花の豆知識</h2>
            <p className="text-gray-600">都道府県の花に関する興味深い情報</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-flower-line text-3xl text-pink-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">最も多い花</h3>
              <p className="text-gray-600">桜やツツジ類が多くの都道府県で県花として選ばれています。日本人に愛される代表的な花です。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">制定時期</h3>
              <p className="text-gray-600">多くの都道府県が1950年代〜1970年代に県花を制定しました。戦後復興期の象徴的な取り組みでした。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">地域性</h3>
              <p className="text-gray-600">各地域の気候や文化を反映した花が選ばれており、その土地の自然環境や歴史を物語っています。</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
